import * as React from 'react'
import {CadastreFilterToWhere, IsValidCadastreFilter} from '../../../helpers/regHelper'
import appConfig from '../../../reducers/appConfig'
import {IFeatureLayerInfo} from '../../interfaces/models'
import {ControlType, IFeatureLayerInfos, QueryTarget} from '../../interfaces/reducers'
import {ImageWMS, TileWMS} from '../../models/ol/Sources'
import Legend from './Legend'
import Axios from 'axios'
import {getMapService} from '../../../core/reducers/map'

class LayerList extends Legend {
  getLayerControl(layerInfo: IFeatureLayerInfo): JSX.Element {
    const hiddenGroups = {...this.props.hiddenGroupsCaches}
    const hiddenGroup = hiddenGroups[layerInfo.sourceDescription.group]
    let isVisible = !!this.props.visibleLayers[layerInfo.url]
    if (hiddenGroup) {
      isVisible = !!hiddenGroup[layerInfo.url]
    }
    if (!layerInfo.getLayer(this.props.zoom)) {
      isVisible = false
    }
    const isActuallyVisible = this.isLayerVisible(layerInfo)

    const add: IFeatureLayerInfo[] = []
    const remove: IFeatureLayerInfo[] = []
    if (isVisible) {
      remove.push(layerInfo)
    } else {
      add.push(layerInfo)
    }

    const visibilityControl = (
      <React.Fragment>
        <input
          style={{transform: 'scale(1)', marginRight: '10px'}}
          className="regular-checkbox"
          type="checkbox"
          checked={isVisible}
          onChange={() => {
            if (hiddenGroup) {
              if (isVisible) {
                delete hiddenGroups[layerInfo.sourceDescription.group][layerInfo.url]
              } else {
                hiddenGroups[layerInfo.sourceDescription.group][layerInfo.url] = layerInfo.url
              }
              this.props.layersDispatcher.setHiddenGroupCaches(hiddenGroups)
            } else {
              this.props.layersDispatcher.changeVisibleLayers(add, remove)
            }
          }}
        ></input>
        <div>{layerInfo.sourceDescription.sourceTitle}</div>
        <div
          style={{
            transform: 'scale(1)',
            marginLeft: '10px'
          }}
        >
          {layerInfo.sourceDescription.minimumz ? '>' + layerInfo.sourceDescription?.minimumz : ''}
        </div>
        {layerInfo.url == appConfig.cadastre.schema.url ? (
          <input
            className="form-control"
            style={{maxWidth: '80px'}}
            type="number"
            min={0}
            value={parseInt(layerInfo.sourceDescription.constantSqlWhere.replace("floornumber='", '').replace("'", ''))}
            onChange={e => {
              let newFloor = parseInt(e.target.value)
              if (isNaN(newFloor)) {
                newFloor = 0
              }
              if (newFloor > -10) {
                layerInfo.sourceDescription.constantSqlWhere = `floornumber='${newFloor}'`
                const query = this.props.dataQueries[appConfig.cadastre.schema.url]
                let where = CadastreFilterToWhere('', layerInfo)
                if (query && query.controledQueries['CadFilter']) {
                  where = CadastreFilterToWhere(query.controledQueries['CadFilter'].controlValue, layerInfo)
                }
                const source = layerInfo.imageLayer.getSource() as TileWMS | ImageWMS
                let params = source.getParams()
                params = {...params, CQL_FILTER: where}
                source.updateParams(params)
                setTimeout(() => {
                  layerInfo.refresh()
                  this.forceUpdate()
                }, 100)
              }
            }}
          />
        ) : null}
      </React.Fragment>
    )
    if (this.props.layerListWithLegend) {
      const imageLegendRows = this.getImages(layerInfo)
      return (
        <div
          key={layerInfo.url}
          style={{
            display: imageLegendRows.length > 1 ? '' : 'flex',
            fontSize: '14px',
            justifyContent: 'space-between'
          }}
        >
          <div
            style={{
              display: 'flex',
              fontSize: '14px',
              color: isActuallyVisible ? '' : this.notVisibleTextColor
            }}
          >
            {visibilityControl}
          </div>
          {isActuallyVisible ? this.getLegendRowSymbology(layerInfo, imageLegendRows.length > 1) : null}
        </div>
      )
    }
    return (
      <div
        key={layerInfo.url}
        style={{
          display: 'flex',
          fontSize: '14px',
          alignItems: 'center',
          color: isActuallyVisible ? '' : this.notVisibleTextColor
        }}
      >
        {visibilityControl}
      </div>
    )
  }

  getCadastreFilter(layerInfos: IFeatureLayerInfos) {
    const schemaQueries = this.props.dataQueries[appConfig.cadastre.schema.url]
    let value = ''
    if (schemaQueries && schemaQueries.controledQueries['CadFilter']) {
      value = schemaQueries.controledQueries['CadFilter'].controlValue
    }
    const valid = IsValidCadastreFilter(value) || !value
    return (
      <div>
        <div style={{display: 'flex', alignItems: 'center'}}>
          <input
            value={value}
            placeholder="Филтър по кадастрален идентификатор"
            className="form-control"
            onChange={e => {
              const newVal = e.target.value //TrimCadFilter()
              this.props.dataQueryDispatcher.setQueries(
                appConfig.cadastre.schema.url,
                {
                  CadFilter: {
                    controlType: ControlType.StringInput,
                    controlValue: newVal,
                    queryTarget: QueryTarget.Map,
                    where: newVal
                  }
                },
                undefined,
                undefined,
                false
              )
            }}
          ></input>
          <button
            type="button"
            className="button"
            disabled={!valid}
            onClick={() => {
              const query = this.props.dataQueries[appConfig.cadastre.schema.url]
              const xyz = query.controledQueries['CadFilter'].controlValue.split('.')
              Axios.get(
                appConfig.urls.xyApiUrl + '/GeoserverWmsProxy/CadastreSettlement?ekatte=' + xyz[0] + '&region=' + xyz[1]
              )
                .then(r => {
                  if (r.data) {
                    getMapService().setCenter([r.data.X, r.data.Y])
                    getMapService().setZoom(17)
                  }
                })
                .catch(e => {
                  if (e.response && e.response.data) {
                    console.log(e.response.data)
                  }
                })
            }}
          >
            Отиди
          </button>
        </div>
        {valid ? null : <div className="error-div">Кадастралният идентификатор може да не е валиден</div>}
      </div>
    )
  }

  getLayerControls(layerInfos: IFeatureLayerInfos): JSX.Element[] {
    const layerControls: JSX.Element[] = []
    for (const i in layerInfos) {
      if (this.processRow(layerInfos[i])) {
        layerControls.push(this.getLayerControl(layerInfos[i]))
      }
    }
    return layerControls
  }

  getGroupedLayers(groupName: string, layerInfos: IFeatureLayerInfos, withVisibilityControl: boolean): JSX.Element {
    if (groupName == 'common') {
      return <div key={groupName}></div>
    }
    return (
      <div key={groupName} className="grouped-layers">
        {groupName ? this.getGroupControl(groupName, layerInfos, withVisibilityControl) : null}
        {!this.state.folded[groupName] && (
          <div className="layers" key={groupName}>
            {groupName == 'cad' && this.getCadastreFilter(layerInfos)}
            {this.getLayerControls(layerInfos)}
          </div>
        )}
      </div>
    )
  }
  render() {
    return <React.Fragment>{this.getLayerGroups(true)}</React.Fragment>
  }
}

export default LayerList
